import {
  BudgetovacDepartmentsDocument,
  type BudgetovacDepartmentsQuery,
  type BudgetovacDepartmentsQueryVariables,
  type CreateBudgetovacPositionInput,
} from "@src/__generated__/graphql";
import type { IOption } from "@src/components/ui-kit";
import { FetchHelper } from "@src/helpers/apollo/fetch";
import type { TToFieldStates } from "@src/utils/forms/ts-utils";
import { required } from "@src/utils/forms/validators";
import mapToOptions from "@src/utils/map-to-options";
import { FieldState, FormState } from "formstate";
import { action, computed, makeObservable, observable } from "mobx";

export abstract class BudgetPositionFormStore {
  form = new FormState<TToFieldStates<CreateBudgetovacPositionInput>>({
    name: new FieldState<CreateBudgetovacPositionInput["name"]>("").validators(
      required,
    ),
    department_id: new FieldState<
      CreateBudgetovacPositionInput["department_id"]
    >(undefined),
  });

  protected departmentsFetcher = new FetchHelper<
    BudgetovacDepartmentsQuery,
    BudgetovacDepartmentsQueryVariables
  >(BudgetovacDepartmentsDocument);

  @observable
  departmentOptions: IOption[] = [];

  constructor() {
    makeObservable(this);
  }

  @computed
  get isLoadingDepartments(): boolean {
    return this.departmentsFetcher.isLoading.value;
  }

  abstract get isSubmitting(): boolean;

  @action.bound
  async fetchDepartments(): Promise<void> {
    const [data, error] = await this.departmentsFetcher.fetch();

    if (!data?.ourWorkBudgetCategories || error) return;

    this.departmentOptions = mapToOptions.toOptions(
      data.ourWorkBudgetCategories,
      "name",
    );
  }
}
